import e from"react";import{Footer as r}from"../styles.js";const s=({children:s,className:t})=>e.createElement(r,{className:t},s);export{s as ModalFooter};
//# sourceMappingURL=ModalFooter.js.map
